import React from 'react'
import './AppComparison.scss'

const AppComparison = ({ compareHeader, diff1, diff2 }) => {

    return (
        <section className="app-comparison-section">
            <div className="container">
                <h2>{compareHeader.title}</h2>
                <p className="description">
                    {compareHeader.description}
                </p>

                <div className="comparison-container">
                    <div className="comparison-column right-border">
                        <h3>{diff1.title}</h3>
                        <ul className="feature-list">
                            {diff1.features.map((feature, index) => (
                                <li key={index} className="feature-item">
                                    <span className="check-icon">✓</span>
                                    <span className="feature-text">{feature.text}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="comparison-column left-margin">
                        <h3>{diff2.title}</h3>
                        <ul className="feature-list ">
                            {diff2.features.map((feature, index) => (
                                <li key={index} className="feature-item">
                                    <span className="check-icon">✓</span>
                                    <span className="feature-text">{feature.text}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AppComparison 